import React from 'react';

export default function TermsAndConditions() {
  return (
    <div className="privacy-policy-page">
      <h1>Terms and Conditions</h1>

      <h2>Key Terms and Conditions</h2>
      <p>
        <strong>Certification Term:</strong> The certification term may vary depending on the specific program, but it's essential to understand the duration and renewal requirements.
      </p>
      <p>
        <strong>Assessment Process:</strong> The standard assessment process typically involves evaluating an organization's workplace environment, policies, and practices.
      </p>
      <p>
        <strong>Payment Terms:</strong> Organizations should understand the fees associated with the certification program, including payment schedules and refund policies.
      </p>
      <p>
        <strong>Intellectual Property:</strong> The certification program's intellectual property, including trademarks and materials, is typically owned by the certifying organization.
      </p>
      <p>
        <strong>Termination:</strong> The certifying organization may terminate the certification agreement for cause, such as breach of terms or misrepresentation.
      </p>

      <h2>Comprehensive Terms and Conditions</h2>
      <p>
        <strong>Acceptable Use:</strong> Organizations must agree to use the certification program's materials and trademarks in accordance with the terms and conditions.
      </p>
      <p>
        <strong>Code of Conduct:</strong> Organizations may be required to adhere to a code of conduct or professional standards.
      </p>
      <p>
        <strong>Confidentiality:</strong> The certifying organization may require organizations to maintain confidentiality regarding the assessment process and certification materials.
      </p>
      <p>
        <strong>Liability:</strong> The certifying organization may limit its liability in case of disputes or damages.
      </p>
      <p>
        <strong>Amendments:</strong> The certifying organization may amend the terms and conditions, and organizations should review these changes regularly.
      </p>

      <h2>Standard Assessment Process</h2>
      <p>
        <strong>Evaluation Criteria:</strong> The assessment process typically evaluates an organization's workplace environment, policies, and practices against specific criteria.
      </p>
      <p>
        <strong>Assessment Tools:</strong> The certifying organization may use various assessment tools, such as surveys, interviews, or on-site evaluations.
      </p>
      <p>
        <strong>Certification Decision:</strong> The certifying organization makes a certification decision based on the assessment results.
      </p>
      <p>
        <strong>Appeals Process:</strong> Organizations may have the opportunity to appeal the certification decision.
      </p>

      <p style={{ marginTop: 32 }}>
        By participating in the Outstanding Workplaces Certification program, organizations acknowledge that they have read, understood, and agree to these terms and conditions.
      </p>
    </div>
  );
}